import { OpenAPI, SettingsService } from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export const getAllWorkLists = SettingsService.getWorkqueuesAllSettingsWorkqueuesAllGet

export const createWorkList =
  SettingsService.createWorkqueueSettingsWorkqueuesCreatePost

export const updateWorkList =
  SettingsService.modifyWorkqueueSettingsWorkqueuesIdUpdatePatch

export const deleteWorkList =
  SettingsService.deleteWorkqueueSettingsWorkqueuesIdDeleteDelete
